<ng-container *ngIf="data?.imageUrl">
  <h5 *ngIf="data?.heroTitle" style="background-color: #007bc6 !important" class="mb-1 bg-primary text-white p-2">{{
    data?.heroTitle }} </h5>
  <section class="container">
    <div class="row">
      <div class="col-12 p-0">
        <img class="img-fluid" [src]="data?.imageUrl" [title]="data?.heroTitle" [alt]="data?.heroTitle">
      </div>
    </div>
  </section>
</ng-container>